// extracted by mini-css-extract-plugin
export var labelWrapper = "_dt-0";